'use client';

import { cn } from '@ifixit/ui/lib/utils';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { type ComponentProps } from 'react';

function ToggleGroup({ className, ...props }: ComponentProps<typeof ToggleGroupPrimitive.Root>) {
   return (
      <ToggleGroupPrimitive.Root
         data-slot="toggle-group"
         className={cn('group/toggle-group', className)}
         {...props}
      />
   );
}

function ToggleGroupItem({
   className,
   ...props
}: ComponentProps<typeof ToggleGroupPrimitive.Item>) {
   return (
      <ToggleGroupPrimitive.Item
         data-slot="toggle-group-item"
         className={cn(className)}
         {...props}
      />
   );
}

export { ToggleGroup, ToggleGroupItem };
